import styled from 'styled-components'

import { Container } from 'components/Container'
import { FooterContainer } from 'components/FooterContainer'
import { SvgImage } from 'components/SvgImage'

import { Color } from 'root-constants'

export const StyledPasswordCheckGate = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: calc(var(--full-height, 100vh) - 61px);
  `,
  Container: styled(Container)`
    width: 100%;
  `,
  Title: styled.h1`
    margin-bottom: 24px;
    font-size: 30px;
    font-weight: 700;
    line-height: 38px;
    text-align: center;
  `,
  Form: styled.form`
    padding-bottom: 34px;

    input:disabled {
      background-color: ${Color.GRAY_20};
      color: ${Color.DARK};
      -webkit-text-fill-color: ${Color.DARK};
      opacity: 1;
    }

    input:disabled + span {
      top: 9px;
      font-size: 14px;
      line-height: 18px;
    }

    input:disabled ~ svg {
      display: none;
    }
  `,
  FooterContainer: styled(FooterContainer)`
    position: static;
    margin-top: auto;
    border-top: none;
  `,
  Hint: styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    align-self: stretch;
    margin: 16px -24px 0;
    padding: 16px 24px 0;
    border-top: 1px solid ${Color.GRAY_30};
    color: ${Color.GRAY};
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
  `,
  HintIcon: styled(SvgImage)`
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin-right: 8px;
  `,
}
